import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import snakecaseKeys from 'snakecase-keys';
import camelCaseRecursive from 'camelcase-keys-recursive';
import { indexAdvanceSettingsRequest, updateAdvanceSettingRequest } from '../../requests/advanceSettings';
import { BasicCard, FormikSelect } from '../../components';
import { listedRemunerationsSettings } from '../AdvanceSettings/CardInfo';
import { conditionsEnum } from '../Balance/Form/FormOptions';
import { useAuthorization } from '../../services/hooks';
import { sendAlert } from '../../actions/utils';

const RemunerationsAdvanceSettings = () => {
  const vListedRemunerationsSettings = listedRemunerationsSettings;
  const canUpdateSettings = useAuthorization('update', 'AdvanceSetting');
  const [settingData, setSettingData] = useState({});
  const dispatch = useDispatch();

  const settingIndex = () => {
    indexAdvanceSettingsRequest({
      dispatch,
      successCallback: response => {
        setSettingData(camelCaseRecursive(response.data));
      }
    });
  };

  const handleSuccessUpdate = message => {
    dispatch(sendAlert({ kind: 'success', message }));
  };

  const settingUpdate = advanceSetting => {
    updateAdvanceSettingRequest(advanceSetting.id, {
      dispatch,
      params: snakecaseKeys({ advanceSetting }),
      formData: true,
      successCallback: () => {
        handleSuccessUpdate('Configuración modificada con éxito');
      }
    });
  };

  const changeSetting = (settIndex, settValue, inputType) => {
    const newSettData = [...settingData];
    if (inputType && inputType === 'selector') {
      newSettData[settIndex].textValue = settValue;
    }
    setSettingData(newSettData);
  };

  const cardBody = ({ text, name, inputType }) => {
    const isToggle = inputType === 'toggle';
    let settIndex = '';
    if (settingData.length) {
      settIndex = settingData.findIndex(value => value.code === name);
      if (settIndex < 0) settIndex = '';
    }

    return (
      <>
        <Row>
          <Col sm={isToggle ? 9 : 8} md={12} lg={isToggle ? 6 : 5} xl={isToggle ? 8 : 6}>
            <p className="text-uppercase mt-1" style={{ letterSpacing: '1.5px' }}>
              {text}
            </p>
          </Col>
          <Col
            xs={6}
            sm={isToggle ? 2 : 3}
            md={6}
            lg={isToggle ? 4 : 5}
            xl={isToggle ? 3 : 6}
            className={`${isToggle ? 'd-flex justify-content-lg-end' : ''}`}
          >
            {inputType === 'selector' && (
              <FormikSelect
                label=""
                options={conditionsEnum}
                isDisabled={!canUpdateSettings}
                value={settingData[settIndex]?.textValue}
                defaultValue={settingData[settIndex]?.textValue}
                placeholder="Seleccionar"
                onChange={data => {
                  changeSetting(settIndex, data.value, 'selector');
                  settingUpdate(settingData[settIndex]);
                }}
              />
            )}
          </Col>
        </Row>
      </>
    );
  };

  useEffect(settingIndex, []);

  return (
    <>
      <Row className="mt-4 mb-2">
        <Col>
          <h2 className="mb-3 mt-3">Ajustes</h2>
        </Col>
      </Row>
      <h4 className="text-uppercase mt-2 mb-3">Configuraciones Generales</h4>
      <Row className="align-items-center">
        {vListedRemunerationsSettings.map(body => (
          <Col key={`asd-${body.name}`} md={6}>
            <BasicCard
              size="100%"
              classNameCard="z-index-auto"
              bodyMarginBottom="-10px"
              colorCard="white"
              divBody
              text={cardBody(body)}
            />
          </Col>
        ))}
      </Row>
    </>
  );
};

export default RemunerationsAdvanceSettings;
